<template lang="pug">
div
  server-data(
    v-if="!item.is_active || isEditMentor"
    ref="serverData"
    v-slot:default="{ serverData, selectProps, loadMoreItems, search }"
    :method="getMentor"
  )
    v-autocomplete-more(
      v-bind="{ ...selectProps, ...$attrs }"
      v-model="mentorId"
      :item-text="(item) => item.user.full_name"
      :disabled="loading"
      item-value="user_id"
      label="Выберите наставника" dense
      rounded filled hide-details
      @update:search-input="search"
      @load-more-items="loadMoreItems"
    )
      template(v-slot:prepend v-if="item.is_active")
        v-btn(
          fab x-small depressed
          color="error"
          :loading="loading"
          @click="isEditMentor = false; mentorId = item.mentor_id"
        ): v-icon mdi-close
      template(v-slot:append-outer v-if="item.is_active")
        tooltip-wrap(text="Сохранить")
          v-btn(
            fab x-small depressed
            color="success"
            :loading="loading"
            @click="changeMentor"
          ): v-icon mdi-check
  template(v-else-if="item.mentor")
    span.text-caption Наставник:
    v-chip(
      v-bind="chipProps" @click="$emit('selectMentored', item.mentor.id )"
    ).ml-2 {{item.mentor.full_name}}
    v-btn.ml-1(
      v-if="!$user.isMentor"
      fab depressed
      x-small
      color="primary"
      @click="isEditMentor = true"
    ): v-icon(small) mdi-pencil
</template>
<script>
export default {
  props: {
    value: { type: Number, default: null },
    item: { type: Object, required: true },
    chipProps: { type: Object, default: () => ({ color: 'primary', small: true, outlined: true }) },
  },
  data() {
    return {
      isEditMentor: false,
      loading: false,
    };
  },
  computed: {
    mentorId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    getMentor(val) {
      return this.$api.users.getOrganizationUsers(this.$user.organization.id, { ...val, 'search[role]': 8, expand: 'user' });
    },
    async changeMentor() {
      this.loading = true;
      const { mentorId } = this;
      const { data } = await this.$api.mentoring.setMentor(
        this.$user.organization.id, this.item.user_id, { mentor_id: mentorId }, { params: { expand: 'mentor' } },
      );
      this.$emit('change', data.data.mentor);
      this.isEditMentor = false;
      this.loading = false;
    },
  },
};
</script>
